// NewKlant.js

import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function NewKlant() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');

  const [values, setValues] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
    contact_firstname: '',
    contact_lastname: '',
    contact_mobile: '',
    is_single_user: false,
    features: {
      private_lessons: false
    }
  });

  const [emailExists, setEmailExists] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleEmailBlur = async () => {
    if (!values.email) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-existence`,
        {
          params: { email: values.email },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      setEmailExists(response.data.exists);
    } catch (error) {
      console.error('Error checking email existence:', error);
    }
  };

  const handleFeatureChange = (featureKey, checked) => {
    setValues((prev) => ({
      ...prev,
      features: {
        ...(prev.features || {}),
        [featureKey]: checked
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (emailExists) {
      alert('Het e-mailadres bestaat al in het systeem.');
      return;
    }

    const payload = {
      ...values,
      is_single_user: Boolean(values.is_single_user),
      features: {
        ...(values.features || {}),
        private_lessons: values.features?.private_lessons === true
      }
    };

    try {
      setIsSaving(true);

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/customer/addCustomer`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      navigate('/klanten');
    } catch (err) {
      console.error('Fout bij toevoegen klant:', err);
      alert(err?.response?.data?.error || 'Klant toevoegen mislukt.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    navigate('/klanten');
  };

  return (
    <div className="bg-white p-4">
      <h2 className="text-center">Nieuwe Klant</h2>
      <hr className="seperator" />

      <form onSubmit={handleSubmit}>
        <div className="mb-3 col">
          <div className="form-check">
            <input
              id="checkbox_single_user"
              type="checkbox"
              className="form-check-input"
              checked={values.is_single_user}
              onChange={(e) =>
                setValues({ ...values, is_single_user: e.target.checked })
              }
            />
            <label className="form-check-label" htmlFor="checkbox_single_user">
              Is dit een single user?
            </label>
          </div>
        </div>

        <div className="mb-3">
          <label>
            Naam Klant <span style={{ color: 'red' }}>*</span>
          </label>
          <input
            id="input_name"
            type="text"
            className="form-control rounded-0"
            required
            value={values.name}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
          />
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>
              Voornaam Contactpersoon <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              id="input_contact_firstname"
              type="text"
              className="form-control rounded-0"
              value={values.contact_firstname}
              required
              onChange={(e) =>
                setValues({ ...values, contact_firstname: e.target.value })
              }
            />
          </div>

          <div className="mb-3 col">
            <label>
              Achternaam Contactpersoon <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              id="input_contact_lastname"
              type="text"
              className="form-control rounded-0"
              value={values.contact_lastname}
              required
              onChange={(e) =>
                setValues({ ...values, contact_lastname: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>
              Email <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              id="input_email"
              type="email"
              className="form-control rounded-0"
              name="email"
              onFocus={() => setEmailExists(false)}
              required
              value={values.email}
              onChange={(e) => setValues({ ...values, email: e.target.value })}
              onBlur={handleEmailBlur}
            />
            {emailExists && (
              <div style={{ color: 'red' }}>
                Dit e-mailadres is al in gebruik.
              </div>
            )}
          </div>

          <div className="mb-3 col">
            <label>Mobiel Contactpersoon</label>
            <input
              id="input_contact_mobile"
              type="text"
              className="form-control rounded-0"
              value={values.contact_mobile}
              onChange={(e) =>
                setValues({ ...values, contact_mobile: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>Telefoonnummer Klant</label>
            <input
              id="input_phone"
              type="text"
              className="form-control rounded-0"
              value={values.phone}
              onChange={(e) => setValues({ ...values, phone: e.target.value })}
            />
          </div>

          <div className="mb-3 col">
            <label>Volledig Adres</label>
            <input
              id="input_address"
              type="text"
              className="form-control rounded-0"
              value={values.address}
              onChange={(e) => setValues({ ...values, address: e.target.value })}
            />
          </div>
        </div>

        <hr className="seperator" />

        <h4 className="mb-3">Modules / functies</h4>
        <div className="alert alert-light border">
          Kies welke modules voor deze klant beschikbaar zijn. Deze instellingen kunnen gebruikt
          worden om menu-items en backend toegang per klant aan of uit te zetten.
        </div>

        <div className="form-check mb-4">
          <input
            className="form-check-input"
            type="checkbox"
            id="feature_private_lessons"
            checked={values.features?.private_lessons === true}
            onChange={(e) => handleFeatureChange('private_lessons', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="feature_private_lessons">
            Privélessen inschakelen
          </label>
          <div className="form-text">
            Hiermee kan deze klant de privélesmodule gebruiken voor ouders, docenten en admins.
          </div>
        </div>

        <hr className="seperator" />

        <div className="row">
          <div className="col-md-6">
            <button
              id="button_cancel"
              type="button"
              className="btn btn-secondary w-100 rounded-0"
              onClick={handleCancel}
              disabled={isSaving}
            >
              Annuleren
            </button>
          </div>
          <div className="col-md-6">
            <button
              id="button_save"
              type="submit"
              className="btn btn-secondary w-100 rounded-0"
              disabled={isSaving}
            >
              {isSaving ? 'Opslaan...' : 'Opslaan'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NewKlant;
